import RenderHTML from './RenderHTML'

type ChevronBox = {
  label: string
  action: () => void
}

type RightChevronBoxGroupPropTypes = {
  boxes: ChevronBox[]
}

const rightChevron = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <g clip-path="url(#clip0_23344_133765)">
    <path d="M9.00045 4.92146L4.08045 0.241457C3.99425 0.159512 3.89276 0.0953479 3.78176 0.0526279C3.67076 0.00990789 3.55244 -0.0105313 3.43354 -0.00752266C3.31464 -0.00451404 3.1975 0.0218835 3.08881 0.0701626C2.98012 0.118442 2.882 0.187657 2.80005 0.273857C2.63456 0.447945 2.545 0.680646 2.55107 0.920767C2.55715 1.16089 2.65836 1.38876 2.83245 1.55426L7.28685 5.78426C7.31641 5.81218 7.33996 5.84585 7.35606 5.8832C7.37215 5.92055 7.38045 5.96079 7.38045 6.00146C7.38045 6.04212 7.37215 6.08236 7.35606 6.11971C7.33996 6.15706 7.31641 6.19073 7.28685 6.21866L2.83245 10.4487C2.65932 10.613 2.55858 10.8395 2.55239 11.0781C2.5462 11.3168 2.63507 11.5481 2.79945 11.7213C2.96383 11.8944 3.19026 11.9951 3.42892 12.0013C3.66758 12.0075 3.89892 11.9186 4.07205 11.7543L9.01245 7.06226C9.15302 6.92134 9.26429 6.75398 9.33983 6.56983C9.41537 6.38568 9.45369 6.18839 9.45258 5.98936C9.45146 5.79032 9.41093 5.59347 9.33333 5.41018C9.25573 5.22689 9.14259 5.06079 9.00045 4.92146Z" fill="#232323"/>
  </g>
  <defs>
    <clipPath id="clip0_23344_133765">
      <rect width="12" height="12" fill="white"/>
    </clipPath>
  </defs>
</svg>`

export const RightChevronBoxGroup = ({ boxes }: RightChevronBoxGroupPropTypes) => {
  return (
    <div className='bg-white rounded-xl w-full'>
      {boxes?.map(({ label, action }, idx) => {
        return (
          <div
            onClick={action}
            key={`${label}-${idx}`}
            className={`w-full flex justify-between items-center pl-4 pt-[15px] pb-[17px] pr-5 ${idx === 0 ? '' : 'border-t border-[#EBF2F2]'}`}
          >
            <div className='text-[14px] text-[#232323]'>{label}</div>
            <div>
              {' '}
              <RenderHTML innerHTMLText={rightChevron} />{' '}
            </div>
          </div>
        )
      })}
    </div>
  )
}
